module.exports = "\n  <div id=\"loader-overlay\">\n    <div class=\"form-row var-full\">\n        <div class=\"form-item var-full\">\n          <label>Add variable from...</label>\n          <div *ngFor=\"let q of questionsForVariable\">\n            <div class=\"dropdown-item full flex\" (click)=\"selectQuestionId(q)\">\n              {{ q.question }}\n            </div>\n          </div>\n        </div>\n      </div>\n  </div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/popover/popover.component.html
// module id = ./src/app/shared/components/popover/popover.component.html
// module chunks = main